import React, { Children, useCallback, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faExclamationCircle, IconLookup, IconName, IconPrefix } from "@fortawesome/free-solid-svg-icons";
import { isServerError } from "../../config/api";
import Format from "../../helpers/Format";
import ConsultarService, { Status, Inscription, Billet, OpcaoParcelamento, Parcelamento } from "../../services/ConsultarService";
import Show from "../Show";
import Modal from "../Modal";
import Alert from "../Alert";
import Boleto from "../Boleto";
import AlertGenerateInstallmentsBilletModal from "../AlertaGerarBoletoParcelas";
import Loader from "../Loader";
import ItemDebito from "../ItemDebito";
import ItemSituacao from "../ItemSituacao";
import ItemInscricao from "../ItemInscricao";
import ItemSituacaoEmpty from "../ItemSituacaoEmpty";
import { useHistory } from "react-router-dom";
import { useQuery } from "../../helpers/Utils";
import Button from "../Form/Button";
import AgilisServices, { EnableRefisBannerParams, GenerateBilletsResponse, GenerateBilletsPayload } from "../../services/AgilisServices";

import "./styles.css";
import { useEffect } from "react";
import moment from "moment";
import { format } from "path";
import { RefisBannerInstallments } from "../RefisBannerInstallments";

interface Props {
  documento: string;
  title: string;
  status: Status;
  reloadSearch(): void;
  totalBalances?: [] | any;
  totalBalancesRefis?: [] | any;
  enabledRefis?: boolean;
  attendant_id?: number;
  showAddress: boolean;
  consultType: string;
  consultValue: string;
}

interface Data {
  title: string;
  subtitle: string;
  showed: boolean;
  selectable: boolean;
  data: Inscription[];
}

const ENABLED_REFIS_RULE_ID: number[] = [109, 110, 111];

const inscriptionCountLabel = (total: number) => `${total} ${total === 1 ? "inscrição" : "inscrições"}`;

export default function ItemTipoReceita({ documento, attendant_id, title, status, reloadSearch, totalBalances, totalBalancesRefis, enabledRefis, showAddress, consultType, consultValue}: React.PropsWithChildren<Props>) {
  const history = useHistory();

  const query = useQuery();
  const digital = Boolean(query.get("digital"));
  const digitalQuery = digital ? "&digital=true" : "";
  const mensagemSelecioneCreditos = "Selecione os débitos que deseja negociar";

  const [show, setShow] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [pendingPayment, setPendingPayment] = useState<{ ids: number[]; pix: boolean }>();
  const [showModalSimulacao, setShowModalSimulacao] = useState(false);
  const [showModalRestriction, setShowModalRestriction] = useState(false);
  const [showConfirmarParcelamento, setShowConfirmarParcelamento] = useState(false);
  const [showParcelamento, setShowParcelamento] = useState(false);
  const [showButtonEfetuarParcelamento, setShowButtonEfetuarParcelamento] = useState(false);
  const [showButtonCancelarParcelamento, setShowButtonCancelarParcelamento] = useState(false);
  const [showConfirmarCancelarParcelamento, setShowConfirmarCancelarParcelamento] = useState(false);

  const [error, setError] = useState("");
  const [errorSimulacao, setErrorSimulacao] = useState("");
  const [errorEfetuarParcelamento, setErrorEfetuarParcelamento] = useState("");
  const [errorCancelarParcelamento, setErrorCancelarParcelamento] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingPix, setLoadingPix] = useState(false);
  const [loadingSimulacao, setLoadingSimulacao] = useState(false);
  const [loadingEfetuarParcelamento, setLoadingEfetuarParcelamento] = useState(false);
  const [loadingCancelarParcelamento, setLoadingCancelarParcelamento] = useState(false);
  const isProcessingBillet = loading || loadingPix;

  const [parcelamento, setParcelamento] = useState<Parcelamento>();
  const [opcoesParcelamento, setOpcoesParcelamento] = useState<OpcaoParcelamento[]>([]);
  const [opcaoSelecionada, setOpcaoSelecionada] = useState<OpcaoParcelamento>();

  const [boleto, setBoleto] = useState<Billet>();
  const [inscricoesSelecionadas, setInscricoesSelecionadas] = useState<number[]>([]);
  const [inscricoesComRestricao, setInscricoesComRestricao] = useState<Inscription[]>([]);
  const [refisHabilitado, setRefisHabilitado] = useState(false);
  const [receiptType, setReceiptType]: any = useState(0)

  const [totalSelected, setTotalSelected] = useState(0);
  const [group, setGroup] = useState<string[]>([]);
  const situacoes = Object.keys(status);
  const visibleSituacoes = situacoes.filter((situacao) => (
    situacao !== "Quitado" || status[situacao].total_inscriptions > 0
  ));

  const [id, setId] = useState("");
  const [extinctCda, setExtintiCda] = useState(false);
  const [extinctCdasLoaded, setExtinctCdasLoaded] = useState(false);
  const [loadingExtinctCdas, setLoadingExtinctCdas] = useState(false);
  const [errorExtinctCdas, setErrorExtinctCdas] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selecteds, setSelecteds] = useState(0)
  const [allSelected, setAllSelected] = useState(false);
  const [selectedValue, setSelectedValue] = useState(0);
  const [selectedRefisValue, setSelectedRefisValue] = useState(0);

  const [showInformations, setShowInformations] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [contributorEmail, setContributorEmail] = useState('');
  const [email, setEmail] = useState('');
  const [validEmail, setValidEmail] = useState(false);
  const [errorAdd, setErrorAdd] = useState(false);
  const [refisEnabled, setRefisEnabled] = useState(false);
  const [refisBannerEnabled, setRefisBannerEnabled] = useState(false);

  useEffect(() => {
    InscriptionsBehavior();
  });

  useEffect(() => {
    const fetchRefisBanner = async () => {
      try {
        const firstStatusKey = Object.keys(status)[0];
        const inscriptionsList = firstStatusKey ? status[firstStatusKey]?.data ?? [] : [];

        if (!inscriptionsList.length) {
          return;
        }

        const params: EnableRefisBannerParams = {
          inscriptions_ids: inscriptionsList.map((inscription) => inscription.id),
        };

        const firstInscription = inscriptionsList[0] as any;

        if (firstInscription?.receipt_type_id != null) {
          params.receipt_type_id = firstInscription.receipt_type_id;
        }

        if (firstInscription?.contributor_id != null) {
          params.contributor_id = firstInscription.contributor_id;
        }

        if (documento) {
          params.contributor_document = documento;
        }

        const response = await AgilisServices.enableRefisBanner(params);

        const enabled = typeof response === "boolean"
          ? response
          : Boolean(
              (response as any)?.enabled ??
              (response as any)?.enable_banner ??
              (response as any)?.refis_enabled ??
              (response as any)?.data ??
              response
            );

        setRefisBannerEnabled(enabled);
      } catch (error) {
        setRefisBannerEnabled(false);
      }
    };

    fetchRefisBanner();
  }, []);

  const [datas, setDatas] = useState<Data[]>(visibleSituacoes.map((situacao, index): Data => {
    if (index === 0) {
      return {
        title: situacao,
        subtitle: Format.currency(status[situacao].total_balance),
        showed: true,
        selectable: true,
        data: status[situacao].data,
      };
    }

    // tslint:disable-next-line: no-magic-numbers
    if (situacao === "Quitado") {
      return {
        title: situacao,
        subtitle: status[situacao].total_inscriptions > 0 ? inscriptionCountLabel(status[situacao].total_inscriptions) : "",
        showed: false,
        selectable: false,
        data: status[situacao].data,
      };
    }

    return {
      title: situacao,
      subtitle: "",
      showed: false,
      selectable: false,
      data: status[situacao].data,
    };
  }));

  const totalInscriptionsOpened = status[situacoes[0]].total_inscriptions;
  const label = totalInscriptionsOpened > 1 ? "inscrições" : "inscrição";

  function resetSelection() {
    datas.map((data) => {
      data.data = data.data.map((inscription) => {
        inscription.selected = false;

        return inscription;
      });

      return data;
    });
  }

  const handleHideModalRestriction = () => setShowModalRestriction(false);

  const handleHideBoleto = () => {
    if (isProcessingBillet) return;
    setShowModal(false);
    setPendingPayment(undefined);
    setBoleto(undefined);
  };

  const handleHideParcelamento = () => {
    setShowParcelamento(false);
    setParcelamento(undefined);
    reloadSearch();
  };

  const handleToggleShow = () => {
    setShow(!show);
  };

  const unselectAll = () => {
    setDatas(datas.map((data) => {
      data.data = data.data.map((inscription) => {
        inscription.selected = false;

        return inscription;
      });

      return data;
    }));
  };

  const selectInscription = (inscricaoSelected: Inscription) => {
    const { id, group_payment, payment_request_code, refis_enabled, receipt_type_id } = inscricaoSelected;

    setDatas(datas.map((data, index) => {
      if (index === 0) {
        if (payment_request_code) {
          data.data = data.data.map((inscription) => {
            if (inscription.id === id && inscription.payment_request_code === payment_request_code) {
              inscription.selected = true;
            }

            return inscription;
          });
        } else {
          data.data = data.data.map((inscription) => {
            if (inscription.id === id) {
              inscription.selected = true;
            }

            return inscription;
          });
        }
      }

      return data;
    }))
    setRefisHabilitado(refis_enabled);
    setReceiptType(receipt_type_id)
    checkShowButtons();
    setGroup([group_payment]);
  };

  const toggleSelectInscription = (inscricaoSelected: Inscription) => {
    setDatas(datas.map((data) => {
      data.data = data.data.map((inscription) => {
        if (inscription.id === inscricaoSelected.id) {
          inscription.selected = !inscription.selected;
        }

        return inscription;
      });

      return data;
    }));

    checkShowButtons();
  };

  const checkShowButtons = () => {
    if (datas[0]) {
      const inscriptions = datas[0].data;
      const inscriptionsSelecteds = inscriptions.filter((inscription) => inscription.selected);
      const inscriptionWithPaymentRequest = inscriptionsSelecteds.find((inscription) => inscription.payment_request_code !== null);

      if (inscriptionWithPaymentRequest && inscriptionWithPaymentRequest.payment_request_code !== null) {
        if (inscriptionWithPaymentRequest.refis_enabled) {
          const paymentRequestCode = inscriptionWithPaymentRequest.payment_request_code;
          const inscriptionsWithPaymentRequest = inscriptions.filter((inscription) => inscription.payment_request_code === paymentRequestCode);

          setShowButtonCancelarParcelamento(inscriptionsSelecteds.length === inscriptionsWithPaymentRequest.length);
          setShowButtonEfetuarParcelamento(false);
        } else {
          setShowButtonCancelarParcelamento(false);
          setShowButtonEfetuarParcelamento(false);
        }

      } else {
        setShowButtonEfetuarParcelamento(inscriptionsSelecteds.length > 0);
        setShowButtonCancelarParcelamento(false);
      }

    }
  };

  const handleSelect = (inscricaoSelected: Inscription) => () => {
    if (inscricaoSelected.group_payment) {
      if (group.includes(inscricaoSelected.group_payment)) {
        toggleSelectInscription(inscricaoSelected);
      } else {
        if (group.length) {
          unselectAll();
        }

        selectInscription(inscricaoSelected);
      }
    }

    if (datas[0]) {
      const inscriptionsSelecteds = datas[0].data.filter((i) => i.selected);
      setInscricoesSelecionadas(inscriptionsSelecteds.map((i) => i.id));
      setTotalSelected(inscriptionsSelecteds.reduce((t, i) => t + i.balance, 0));
      if (inscriptionsSelecteds.length === 0) {
        setGroup([]);
        setRefisHabilitado(false);
      }
    }
  };

  // const handleSubmit = async (inscriptions?: number[]) => {
  //   setLoading(true);
  //   try {
  //     await ConsultarService
  //       .gerarBoleto(inscriptions || inscricoesSelecionadas)
  //       .then((response) => {
  //         setShowModal(true);
  //         setShowModalSimulacao(false);
  //         setTotalSelected(0);
  //         setInscricoesSelecionadas([]);
  //         resetSelection();
  //         setGroup([]);
  //         setError("");
  //         setBoleto(response);
  //       }).catch((err) => {
  //         if (err instanceof Error) {
  //           setError("Não foi possível estabelecer uma conexão com o servidor. Tente novamente mais tarde.");
  //         } else if (isServerError(err)) {
  //           setError(err.error);
  //         } else {
  //           console.error(err);
  //         }
  //       }).finally(() => setLoading(false));
  //   } catch (err) {
  //     setLoading(false);
  //   }
  // };

  const createBilletPayload = useCallback((selectedIds: number[]): GenerateBilletsPayload => {
    const selectedInscriptions = datas[0]?.data.filter((item) => selectedIds.includes(item.id)) || [];
    const firstSelected = selectedInscriptions[0] as any;

    const payload: GenerateBilletsPayload = {
      contributor_id: firstSelected?.contributor_id ?? "",
      receipt_type_id: firstSelected?.receipt_type_id ?? 0,
      inscriptions_ids: selectedIds,
    };

    if (contributorEmail) {
      payload.email = contributorEmail;
    }

    return payload;
  }, [contributorEmail, datas]);

  const requestBillet = useCallback((selectedIds: number[]) => {
    const payload = createBilletPayload(selectedIds);
    return AgilisServices.generateBillets(payload);
  }, [createBilletPayload]);

  const handleBilletError = (err: unknown, fallbackMessage = "Não foi possível estabelecer uma conexão com o servidor. Tente novamente mais tarde.") => {
    if (err instanceof Error) {
      setError(fallbackMessage);
    } else if (isServerError(err)) {
      setError(err.error || fallbackMessage);
    } else {
      console.error(err);
      setError(fallbackMessage);
    }
  };

  const extractPixData = (response: GenerateBilletsResponse | undefined) => {
    const getPixFields = (target?: Record<string, unknown>) => {
      if (!target) {
        return { copyPast: undefined, qrCode: undefined };
      }

      return {
        copyPast: typeof target.copy_past === "string" ? target.copy_past : undefined,
        qrCode: typeof target.qr_code === "string" ? target.qr_code : undefined,
      };
    };

    if (!response || typeof response !== "object") {
      return getPixFields();
    }

    const base = response as Record<string, unknown>;

    if (base.pix && typeof base.pix === "object") {
      return getPixFields(base.pix as Record<string, unknown>);
    }

    if (base.billet && typeof base.billet === "object") {
      const billetData = base.billet as Record<string, unknown>;
      if (billetData.pix && typeof billetData.pix === "object") {
        return getPixFields(billetData.pix as Record<string, unknown>);
      }
    }

    return getPixFields(base);
  };

  const handleSubmit = async (inscriptions?: number[], confirmed = false) => {
    setLoading(true);
    const selectedIds = inscriptions || inscricoesSelecionadas;

    try {
      setError("");
      if (!confirmed && await AgilisServices.previousBillets({ inscriptions_ids: selectedIds })) {
        setPendingPayment({ ids: [...selectedIds], pix: false });
        setBoleto(undefined);
        setShowModalSimulacao(false);
        setShowModal(true);
        return;
      }
      const response = await requestBillet(selectedIds);
      setPendingPayment(undefined);
      setShowModal(true);
      setShowModalSimulacao(false);
      setTotalSelected(0);
      setInscricoesSelecionadas([]);
      resetSelection();
      setGroup([]);
      setError("");
      setBoleto(response as unknown as Billet);
    } catch (err) {
      handleBilletError(err, "Não foi possível gerar o pagamento no momento, por favor, tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  };

  const handlePixPayment = async (confirmed = false, selectedIds = inscricoesSelecionadas) => {
    if (!selectedIds.length) {
      return;
    }

    setLoadingPix(true);

    try {
      setError("");
      if (!confirmed && await AgilisServices.previousBillets({ inscriptions_ids: selectedIds })) {
        setPendingPayment({ ids: [...selectedIds], pix: true });
        setBoleto(undefined);
        setShowModalSimulacao(false);
        setShowModal(true);
        return;
      }
      const response = await requestBillet(selectedIds);
      setPendingPayment(undefined);
      setShowModal(false);
      const { copyPast, qrCode } = extractPixData(response);

      const params = new URLSearchParams();
      params.set("inscriptions", selectedIds.join(","));
      if (totalSelected > 0) {
        params.set("total", String(totalSelected));
      }

      if (copyPast) {
        params.set("copy_past", copyPast);
      }

      if (qrCode) {
        params.set("qr_code", qrCode);
      }

      const search = params.toString();
      const url = search ? `/pagamento/pix?${search}` : "/pagamento/pix";

      if (typeof window !== "undefined") {
        window.open(url, "_blank", "noopener");
      }

      setTotalSelected(0);
      setInscricoesSelecionadas([]);
      resetSelection();
      setGroup([]);
      setError("");
    } catch (err) {
      handleBilletError(err);
    } finally {
      setLoadingPix(false);
    }
  };

  const handleConfirmarParcelamento = () => {
    setShowConfirmarParcelamento(true);
    setErrorSimulacao("");
    setErrorEfetuarParcelamento("");
  };

  const handleDesistirParcelamento = () => {
    setShowModalSimulacao(false);
    setShowConfirmarParcelamento(false);
    setOpcaoSelecionada(undefined);
    setOpcoesParcelamento([]);
    setShowInformations(false);
    setValidEmail(false);
    setAcceptTerms(false);
  };

  const handleEfetuarParcelamento = async () => {
    setLoadingEfetuarParcelamento(true);
    setErrorSimulacao("");
    setErrorEfetuarParcelamento("");
    try {
      if (opcaoSelecionada) {
        await ConsultarService
          .gerarParcelamento(inscricoesSelecionadas, opcaoSelecionada.num_installments, opcaoSelecionada.refis_rule_id, attendant_id, documento)
          .then((response) => {
            setParcelamento(response);
            handleDesistirParcelamento();
            setShowParcelamento(true);
            sendInstallmentEmail(response);
          }).catch((err) => {
            if (isServerError(err)) {
              setErrorEfetuarParcelamento(err.error);
            } else {
              console.error(err);
            }
          }).finally(() => {
            setLoadingEfetuarParcelamento(false);
          });
      } else {
        setErrorEfetuarParcelamento("Selecione uma opção para efetuar o parcelamento.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSimulacao = async (inscriptions?: number[], installments?: OpcaoParcelamento) => {
    setShowModalRestriction(false);
    setLoadingSimulacao(true);
    setShowModalSimulacao(true);
    setParcelamento(undefined);
    setErrorEfetuarParcelamento("");
    setErrorSimulacao("");
    try {
      await ConsultarService
        .simulacaoParcelamento(inscriptions || inscricoesSelecionadas)
        .then((response) => {
          setOpcoesParcelamento(response);
          if (installments) {
            setOpcaoSelecionada(installments);
            setShowInformations(true);
          };
        }).catch((err) => {
          if (isServerError(err)) {
            setErrorSimulacao(err.error);
          } else {
            console.error(err);
          }
        }).finally(() => {
          setLoadingSimulacao(false);
        });
    } catch (err) {
      setLoadingSimulacao(false);
      console.error(err);
    }
  };

  const handleToConsultarParcelamentos = () => {
    setShowModal(false);
    setShowModalSimulacao(false);
    setShowConfirmarParcelamento(false);
    setShowParcelamento(false);
    // tslint:disable-next-line: no-magic-numbers
    setTimeout(() => history.push(`/consultar/parcelamentos?d=${documento}&n=${parcelamento?.code}${digitalQuery}`), 500);
  };

  const handleShowConfirmarCancelarParcelamento = () => {
    setShowConfirmarCancelarParcelamento(true);
  };

  const handleHideConfirmarCancelarParcelamento = () => {
    setShowConfirmarCancelarParcelamento(false);
  };

  const handleConfirmarCancelarParcelamento = async () => {
    const numeroParcelamento = datas[0].data.find((inscricao) => inscricoesSelecionadas.includes(inscricao.id))?.payment_request_code;
    if (numeroParcelamento) {
      setLoadingCancelarParcelamento(true);
      try {
        await ConsultarService
          .cancelarParcelamento(inscricoesSelecionadas, numeroParcelamento)
          .then((response) => {
            setDatas(datas.map((data) => {
              data.data = data.data.map((inscription) => {
                if (inscricoesSelecionadas.includes(inscription.id)) {
                  const inscriptionResponse = response.inscriptions.find((i) => i.id === inscription.id);

                  if (inscriptionResponse) {
                    return inscriptionResponse;
                  }
                }

                return inscription;
              });

              return data;
            }));
            checkShowButtons();
            handleHideConfirmarCancelarParcelamento();
          }).catch((err) => {
            if (isServerError(err)) {
              setErrorCancelarParcelamento(err.error);
            } else {
              console.error(err);
            }
          }).finally(() => {
            setLoadingCancelarParcelamento(false);
          });
      } catch (err) {
        setLoadingCancelarParcelamento(false);
        console.error(err);
      }
    }
  };

  const handleToConsultNegotiation = (inscription_id: number) => {
    datas.forEach((data) => {
      data.data.forEach((inscription) => {
        if (inscription_id ===inscription.id) {
          setTimeout(() => window.open(`/consultar/parcelamentos?d=${documento}&n=${inscription.payment_request_code}`, "_blank"), 500);
        }
      })
    });
  };

  const handleVerificaInscricoesComRestricoes = useCallback(() => {
    const inscricoesComRestricaoEncontrada: Inscription[] = [];

    datas.forEach((data) => {
      data.data.forEach((inscription) => {
        if (inscricoesSelecionadas.includes(inscription.id) && inscription.refis_enabled && inscription.has_restriction) {
          inscricoesComRestricaoEncontrada.push(inscription);
        }
      })
    });

    // if (inscricoesComRestricaoEncontrada.length) {
    //   setInscricoesComRestricao(inscricoesComRestricaoEncontrada);
    //   setShowModalRestriction(true);
    // } else {
      handleSimulacao();
    // }
  }, [inscricoesSelecionadas]);

  const setVisibleCdas = (element: any) => {
    const allDivs = document.getElementsByClassName("groupBody");
    const divGroupment = document.getElementById(element);
    const chieldDiv = divGroupment?.firstElementChild;

    Array.from(allDivs).map((div) => {
      const groupmentSelected = div.firstElementChild;
      if(div.classList.contains("groupBodySelected")){
        groupmentSelected?.classList.remove("groupmentsOpenned");
        div.classList.remove("groupBodySelected");
      }
    });

    setId(element);

    chieldDiv?.classList.add("groupmentsOpenned");
    divGroupment?.classList.add("groupBodySelected");

    if (id == element && chieldDiv?.classList.contains("groupmentsOpenned")) {
      setId('');
      divGroupment?.classList.remove("groupBodySelected");
      chieldDiv?.classList.remove("groupmentsOpenned");
    };

    clearSelections();
  }

  const setVisibleCdasNegotiation = (element: any) => {
    const allDivs = document.getElementsByClassName("groupBody");
    const divGroupment = document.getElementById(element);
    const chieldDiv = divGroupment?.firstElementChild;

    Array.from(allDivs).map((div) => {
      const groupmentSelected = div.firstElementChild;
      if(div.classList.contains("groupBodySelectedNegotiation")){
        groupmentSelected?.classList.remove("negotiationGroupmentSelected");
        div.classList.remove("groupBodySelectedNegotiation");
      }
    });

    setId(element);

    chieldDiv?.classList.add("negotiationGroupmentSelected");
    divGroupment?.classList.add("groupBodySelectedNegotiation");

    if (id == element && chieldDiv?.classList.contains("negotiationGroupmentSelected")) {
      setId('');
      divGroupment?.classList.remove("groupBodySelectedNegotiation");
      chieldDiv?.classList.remove("negotiationGroupmentSelected");
    };

    clearSelections();
  }

  const loadExtinctCdas = async () => {
    if (extinctCdasLoaded || loadingExtinctCdas) {
      return;
    }

    setLoadingExtinctCdas(true);
    setErrorExtinctCdas("");

    try {
      const response = await ConsultarService.debitosExtintos(documento, consultType, consultValue);
      const extinctStatus = response.data && response.data[title] && response.data[title]["Quitado"];

      setDatas(datas.map((data) => {
        if (data.title === "Quitado") {
          return {
            ...data,
            subtitle: extinctStatus
              ? inscriptionCountLabel(extinctStatus.total_inscriptions)
              : "0 inscrição",
            data: extinctStatus ? extinctStatus.data : [],
          };
        }

        return data;
      }));
      setExtinctCdasLoaded(true);
    } catch (err) {
      if (isServerError(err)) {
        if (err.error === "Débitos não encontrados para os dados informados." || err.error === "Não existem débitos para o CPF/CNPJ informado.") {
          setDatas(datas.map((data) => data.title === "Quitado" ? { ...data, subtitle: "0 inscrição", data: [] } : data));
          setExtinctCdasLoaded(true);
        } else {
          setErrorExtinctCdas(err.error);
        }
      } else {
        setErrorExtinctCdas("Não foi possível consultar as inscrições extintas. Tente novamente mais tarde.");
        console.error(err);
      }
    } finally {
      setLoadingExtinctCdas(false);
    }
  };

  const setVisibleExtinctCdas = (element: any) => {
    const extinctGroupment = document.getElementById(element);
    const extinticChild = extinctGroupment?.firstElementChild

    extinctGroupment?.classList.add("extinticGroupBodySelected");
    extinticChild?.classList.add("extinctGroupmentSelected");

    if(extinctCda == false) {
      setExtintiCda(true);
      loadExtinctCdas();
    }else {
      setExtintiCda(false);
      extinctGroupment?.classList.remove("extinticGroupBodySelected");
      extinticChild?.classList.remove("extinctGroupmentSelected");
    }
  }

  const icon = faChevronUp;
  const iconTitle = "Clique para visualizar";

  const icon2 = faChevronDown;
  const iconTitle2 = "Clique para esconder";

  const showCount = () => {
    const listElements = document.querySelectorAll("#checkboxInscription");
    var groupmentValue = 0;
    Array.from(listElements).map((checkBox) => {
      const inscriptionValue = parseFloat(checkBox.getAttribute("data-value") as string);
      groupmentValue = (groupmentValue + inscriptionValue);
    })
    const groupValueElement = document.getElementById(groupmentValue.toFixed(2).toString());
    const getFirstChild = groupValueElement?.firstElementChild as HTMLElement;
    const getSecoundElementChild = groupValueElement?.children[1] as HTMLElement;
    const getSecoundChild = groupValueElement?.children[2];
    const getThirdChild = groupValueElement?.lastElementChild;
    getFirstChild.classList.add("dynamicGroupHide");
    getSecoundElementChild.classList.add("dynamicGroupHide");
    getSecoundChild?.classList.remove("dynamicGroupHide");
    getThirdChild?.classList.remove("dynamicGroupHide");
  }

  const selectInscriptions = () => {
    const inputElement = document.querySelectorAll("#checkboxInscription");
    Array.from(inputElement).map((eachone) => {
      const element = eachone as HTMLElement;
      const inscriptionId = parseInt(element.getAttribute("data-id") as string);
      datas.map((data) => {
        data.data.map((inscription) => {
          if(inscription.id == inscriptionId) {
            handleSelect(inscription);
          };
        });
      });
    });
  };

  const InscriptionsBehavior = () => {
    const inputElement = document.querySelectorAll("#checkboxInscription");
    const clearButton = document.getElementById("clearButton");
    const selectionInformations = document.getElementById("inscriptionsQuantity");
    const elementButton = document.getElementById("selectAll");
    const installmentBtn = document.getElementById("installmentBtn");
    const ticketBtn = document.getElementById("ticketBtn");
    var arrayElements: Array<Element> = [];
    Array.from(inputElement).map((eachone) => {
      arrayElements.push(eachone);
      const element = eachone as HTMLElement;
      const refisEnabled =  element.getAttribute("data-refisenabled") as unknown as boolean;
      const inscriptionValue = refisEnabled ?
                                  parseFloat(element.getAttribute("data-refisvalue") as string)
                                : parseFloat(element.getAttribute("data-value") as string);
      const inscriptionRefisValue = refisEnabled ?
                                  parseFloat(element.getAttribute("data-value") as string)
                                : parseFloat(element.getAttribute("data-refisvalue") as string);
      element.onchange = function() {
        setSelectedValue(selectedValue + inscriptionValue);
        setSelectedRefisValue(selectedRefisValue + inscriptionRefisValue)
        if(element.hasAttribute("checked")){
          showCount();
          clearButton?.classList.add("clearAllSelections");
          setSelecteds(selecteds + 1);
          selectionInformations?.classList.remove("insciptionSelectedsInvisible");
          selectionInformations?.classList.add("insciptionSelecteds");
          installmentBtn?.classList.add("installmentButton");
          ticketBtn?.classList.add("ticketButton");
          installmentBtn?.classList.remove("installmentButtonDisabled");
          ticketBtn?.classList.remove("ticketButtonDisabled");
          selectInscriptions();

        }else {
          setSelecteds(selecteds - 1);
          setAllSelected(false);
          setIsChecked(false);
          elementButton?.classList.remove("selectAllButtonMarked");
          selectionInformations?.classList.remove("insciptionSelectedsInvisible");
          selectionInformations?.classList.add("insciptionSelecteds");
          setSelectedValue(selectedValue - inscriptionValue);
          setSelectedRefisValue(selectedRefisValue - inscriptionRefisValue)
          selectInscriptions();
        };
        if (!(arrayElements.find(element => element.hasAttribute("checked")))) {
          clearSelections();
          setSelecteds(0);
          setSelectedValue(0);
          setSelectedRefisValue(0)
          installmentBtn?.classList.remove("installmentButton");
          ticketBtn?.classList.remove("ticketButton");
          installmentBtn?.classList.add("installmentButtonDisabled");
          ticketBtn?.classList.add("ticketButtonDisabled");
        };
        const elementsCheked = arrayElements.filter(item => (item as HTMLInputElement).checked);
        if(elementsCheked.length == arrayElements.length){
          setIsChecked(true);
          setAllSelected(true);
          elementButton?.classList.add("selectAllButtonMarked");
          selectionInformations?.classList.add("insciptionSelectedsInvisible");
          selectionInformations?.classList.remove("insciptionSelecteds");
        };
      };
    });
  };

  const MarkAllInscriptions = (selected : boolean, groupPayment : string, refisEnabled: boolean) => {
    if (datas[0]) {
      datas[0].data.map((items) => {
        if(items.group_payment === groupPayment) {
          items.selected = selected;
          setGroup([groupPayment]);
          setRefisHabilitado(refisEnabled);
          checkShowButtons();
        }
      })
      const inscriptionsSelecteds = datas[0].data.filter((i) => i.selected);
      setInscricoesSelecionadas(inscriptionsSelecteds.map((i) => i.id));
      setTotalSelected(inscriptionsSelecteds.reduce((t, i) => t + i.balance, 0));
      if (inscriptionsSelecteds.length === 0) {
        setGroup([]);
        setRefisHabilitado(false);
      }
    }
  }

  const selectAllInscriptions = (element : any) => {
    const elementButton = document.getElementById(element);
    const listElements = document.querySelectorAll("#checkboxInscription");
    const Elements = listElements[0] as HTMLElement;
    const grouPayment = Elements.getAttribute("data-grouppayment") as string;
    const refisEnabled = (Elements.getAttribute("data-refisEnabled") == 'false' ? false : true);
    const selectionInformations = document.getElementById("inscriptionsQuantity");
    const installmentBtn = document.getElementById("installmentBtn");
    const ticketBtn = document.getElementById("ticketBtn");
    if(isChecked) {
      setIsChecked(false);
      setSelecteds(0);
      clearSelections();
      setAllSelected(false);

      elementButton?.classList.remove("selectAllButtonMarked");
      const clearButton = document.getElementById("clearButton");
      clearButton?.classList.remove("clearAllSelections");
      selectionInformations?.classList.add("insciptionSelectedsInvisible");
      selectionInformations?.classList.remove("insciptionSelecteds");
      installmentBtn?.classList.remove("installmentButton");
      ticketBtn?.classList.remove("ticketButton");
      installmentBtn?.classList.add("installmentButtonDisabled");
      ticketBtn?.classList.add("ticketButtonDisabled");
      Array.from(listElements).map((box) => {
        box.removeAttribute("checked");
        const boxElement = box as HTMLInputElement;
        boxElement.checked = false;
      })
      MarkAllInscriptions(false, grouPayment, refisEnabled);
    }else {
      setIsChecked(true);
      setAllSelected(true);
      setSelectedValue(0);
      setSelectedRefisValue(0)
      setSelecteds(listElements.length);

      showCount();
      MarkAllInscriptions(true, grouPayment, refisEnabled);

      const clearButton = document.getElementById("clearButton");
      elementButton?.classList.add("selectAllButtonMarked");
      clearButton?.classList.add("clearAllSelections");
      installmentBtn?.classList.add("installmentButton");
      ticketBtn?.classList.add("ticketButton");
      installmentBtn?.classList.remove("installmentButtonDisabled");
      ticketBtn?.classList.remove("ticketButtonDisabled");
      var totalValue = 0
      var totalRefisValue = 0
      Array.from(listElements).map((box) => {
        const refisEnabled = box.getAttribute("data-refisenabled") as unknown as boolean;
        totalValue = refisEnabled ?
                                totalValue + parseFloat(box.getAttribute("data-refisvalue") as string)
                              : totalValue + parseFloat(box.getAttribute("data-value") as string);
        totalRefisValue = refisEnabled ?
                                totalRefisValue + parseFloat(box.getAttribute("data-value") as string)
                              : totalRefisValue + parseFloat(box.getAttribute("data-refisvalue") as string);
        box.setAttribute("checked", "true");
        const boxElement = box as HTMLInputElement;
        boxElement.checked = true;
      })
      setSelectedValue(totalValue);
      setSelectedRefisValue(totalRefisValue);
      selectionInformations?.classList.add("insciptionSelectedsInvisible");
      selectionInformations?.classList.remove("insciptionSelecteds");
    }
  }

  const clearSelections = () => {
    setIsChecked(false);
    setAllSelected(false);
    setSelecteds(0);
    setSelectedValue(0);
    setSelectedRefisValue(0);
    const selectionInformations = document.getElementById("inscriptionsQuantity");
    const removeAll = document.getElementById("selectAll");
    const clearButton = document.getElementById("clearButton");
    const elementsUnmark = document.querySelectorAll("#checkboxInscription");
    const installmentBtn = document.getElementById("installmentBtn");
    const ticketBtn = document.getElementById("ticketBtn");
    removeAll?.classList.remove("selectAllButtonMarked");
    clearButton?.classList.remove("clearAllSelections");
    Array.from(elementsUnmark).map((box) => {
      box.removeAttribute("checked");
      const boxElement = box as HTMLInputElement;
      boxElement.checked = false;
    })

    hideReset();

    selectionInformations?.classList.add("insciptionSelectedsInvisible");
    selectionInformations?.classList.remove("insciptionSelecteds");
    installmentBtn?.classList.remove("installmentButton");
    ticketBtn?.classList.remove("ticketButton");
    installmentBtn?.classList.add("installmentButtonDisabled");
    ticketBtn?.classList.add("ticketButtonDisabled");
  }

  const hideReset = () => {
    const listElements = document.querySelectorAll("#checkboxInscription");
    var groupmentValue = 0

    Array.from(listElements).map((checkBox) => {
      const inscriptionValue = parseFloat(checkBox.getAttribute("data-value") as string);
      groupmentValue = (groupmentValue + inscriptionValue);
    })

    const groupValueElement = document.getElementById(groupmentValue.toFixed(2).toString());
    if(groupValueElement != null || groupValueElement == 0){
      const getFirstChild = groupValueElement?.firstElementChild as HTMLElement;
      const getSecoundElementChild = groupValueElement?.children[1] as HTMLElement;
      const getSecoundChild = groupValueElement?.children[2];
      const getThirdChild = groupValueElement?.lastElementChild;
      getFirstChild.classList.remove("dynamicGroupHide");
      getSecoundElementChild.classList.remove("dynamicGroupHide")
      getSecoundChild?.classList.add("dynamicGroupHide");
      getThirdChild?.classList.add("dynamicGroupHide");
    }

    if (datas[0]) {
      datas[0].data.map((items) => {
        items.selected = false;
      })
      const inscriptionsSelecteds = datas[0].data.filter((i) => i.selected);
      setInscricoesSelecionadas(inscriptionsSelecteds.map((i) => i.id));
      setTotalSelected(inscriptionsSelecteds.reduce((t, i) => t + i.balance, 0));
      if (inscriptionsSelecteds.length === 0) {
        setGroup([]);
        setRefisHabilitado(false);
      };
    };
  };

  const groupmentTitle = (oppenedInsciptions: number, isAgreement: boolean) => {
    if (isAgreement) {
      return <span className="opennedNegotiation">{`Negociação em aberto com ${oppenedInsciptions} ${oppenedInsciptions > 1 ? "Inscrições" : "Inscrição"}`}</span>
    } else {
      return <span>{`${oppenedInsciptions} ${oppenedInsciptions > 1 ? "Inscrições" : "Inscrição"} em aberto`}</span>
    }
  }

  const groupmentsString = (groupment: string) => {
    if (groupment == null) {
      return 'sent_protest';
    } else {
      return groupment;
    }
  }

  const handleSelecionarOpcao = (opcao: OpcaoParcelamento) => () => {
    setOpcaoSelecionada(opcao);
    setShowInformations(true);
  };

  const termsAccepted = () => { !acceptTerms ? setAcceptTerms(true) : setAcceptTerms(false) };

  const validateEmail = (value = email) => {
    const normalizedEmail = value.trim();
    const validationemail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(normalizedEmail);
    const inputField = (document.getElementById('emailrequired')as HTMLInputElement | null);
    if(normalizedEmail.length === 0){
      inputField?.classList.remove('errorfield');
      setValidEmail(false);
    }else if(validationemail) {
      inputField?.classList.remove('errorfield');
      setValidEmail(true);
      setErrorAdd(false);
    }else {
      inputField?.classList.add('errorfield');
      setValidEmail(false);
      setErrorAdd(true);
    }
  };

  const updateAndValidate = (e: string) => {
    const normalizedEmail = e.trim();
    setEmail(e);
    setContributorEmail(normalizedEmail);
    validateEmail(e);
  };

  const submitAttendance = async () => {
    const contributor_document = documento
    const contributor_attendance_histories = {'attendance_place':'Portal do Contribuinte - Consultar Dívidas',
                                              'attendant':'Assitente Virtual',
                                              'attendance_subject':'term_accepted'};
    const attendanceData = {contributor_document, contributor_attendance_histories};

    await ConsultarService
      .attendanceRegistration(attendanceData)
  };

  const aceptAndContinue = () => {
    handleConfirmarParcelamento()
    submitAttendance();
  };

  const sendInstallmentEmail = async (response: any) => {
    const contributor_document = documento
    const installment_code = response.code;
    const emailData = contributorEmail
    const installmentData = {contributor_document: contributor_document, installment_code: installment_code, emailData: emailData}
    await ConsultarService
      .sendEmailConfirmation(installmentData)
  }

  const returRefisValue = () => (
    totalBalances.map((balancewithoutRefis: any) => (
      balancewithoutRefis.type == title &&
      <div className="totalTributeBalanceRefis">
        <strong>Valor total do tributo com </strong>
        <strong className="refisLabel">REFIS</strong>
        <strong>: </strong>
        <span className="balanceValue">{Format.currency(balancewithoutRefis.balance)}</span>
      </div>
    ))
  );

  const returnTributeValuesRefisEnabled = () => {
    return (
      totalBalancesRefis.map((balanceInfo: any) => {
        if(balanceInfo.type == title) {
          return(
            <div className="totalTributeBalance">
              <strong>Valor total do tributo: </strong>
              {Format.currency(balanceInfo.balance)}
              {returRefisValue()}
            </div>
          )
        }
      })
    )
  };

  const returnTributeValues = () => {
    return (
      totalBalances.map((balanceInfo: any) => {
        if(balanceInfo.type == title) {
          return(
            <div className="totalTributeBalance">
              <strong>Valor total do tributo: </strong>
              {Format.currency(balanceInfo.balance)}
            </div>
          )
        }
      })
    )
  }

  const handleBannerClick = (installments: OpcaoParcelamento, inscriptions: number[]) => {
    if (installments.num_installments === 1) handleSubmit(inscriptions);
    else {
      handleSimulacao(inscriptions, installments);
    };
  }

  return (
    <div className="itenContent" data-refis-banner-enabled={refisBannerEnabled}>
      <div className="detailedInformations">
        <Show if={show}>
          <Modal title="Alerta de restrição" show={showModalRestriction} onHide={handleHideModalRestriction}>
            <div className="simulacao-parcelamento text-center">
              <p className="text-center">
                Algumas das inscrições selecionadas possui restrições de quantidade
                de parcelas a serem parceladas. Segue abaixo as inscrições que estão
                com restrições:
              </p>
              <ul className="list-unstyled">
                {inscricoesComRestricao.map((inscricao) => (
                  <li key={inscricao.id}>CDA: {inscricao.cda}</li>
                ))}
              </ul>
              <p className="text-center">
                Isso afetará a quantidade de vezes que seu parcelamento poderá ser realizado.<br/>
                Deseja continuar?
              </p>
              <button className="btn btn-outline-primary" style={{marginRight: "10px"}} onClick={handleHideModalRestriction}>Não</button>
              <button className="btn btn-primary" onClick={() => handleSimulacao()}>Sim</button>
            </div>
          </Modal>
          <Modal title="Confirmação de cancelamento" show={showConfirmarCancelarParcelamento} onHide={handleHideConfirmarCancelarParcelamento}>
            <div className="simulacao-parcelamento text-center">
              {errorCancelarParcelamento && <Alert>{errorCancelarParcelamento}</Alert>}
              <p className="text-center">O cancelamento do seu parcelamento atual implica modificação das regras atuais e a adesão aos benefícios do novo Programa. Deseja continuar?</p>
              <button className="btn btn-outline-primary" disabled={loadingCancelarParcelamento} style={{marginRight: "10px"}} onClick={handleHideConfirmarCancelarParcelamento}>Não</button>
              <button className="btn btn-primary" disabled={loadingCancelarParcelamento} onClick={handleConfirmarCancelarParcelamento}>Sim</button>
            </div>
          </Modal>
          <Modal show={showModal} onHide={handleHideBoleto}>
            {error && <Alert>{error}</Alert>}
            {pendingPayment && (
              <AlertGenerateInstallmentsBilletModal
                loadingBoleto={isProcessingBillet}
                inCash
                hasPreviousBillet
                showOverdueWarning={false}
                onCancel={handleHideBoleto}
                onConfirm={() => pendingPayment.pix
                  ? handlePixPayment(true, pendingPayment.ids)
                  : handleSubmit(pendingPayment.ids, true)}
              />
            )}
            {boleto && <Boleto boleto={boleto} onHide={handleHideBoleto} />}
          </Modal>
          <Modal title="Parcelamento" show={showParcelamento} onHide={handleHideParcelamento}>
            {parcelamento && (
              <div className="modal-parcelamento">
                <p>Seu parcelamento foi efetuado com sucesso.</p>
                <p>Utilize o número do parcelamento abaixo para consultar e emitir o boleto.</p>
                <p><strong>Número do Parcelamento: {parcelamento.code}</strong></p>
                <button className="btn btn-outline-primary" onClick={handleToConsultarParcelamentos}>
                  Consultar Parcelamento
                </button>
              </div>
            )}
          </Modal>
          <Modal title={showConfirmarParcelamento ? "" : "Simulação de Parcelamento"} show={showModalSimulacao} onHide={handleDesistirParcelamento}>
            <Show if={!showConfirmarParcelamento}>
              <div className="simulacao-parcelamento">
                {errorSimulacao && <Alert>{errorSimulacao}</Alert>}
                {(refisHabilitado) && receiptType === 171 && (
                  <>
                    <p>
                      Parcelamento simulado no Refis-TMRSU com os descontos previsto na Lei Nº 11.521/2025.
                    </p>
                    <p>
                      Conforme o art. 5º, os decontos do REFIS somente incidem sobre juros e multas de natureza moratória, da atualização monetária e das multas de caráter punitivo, quando houver.
                    </p>
                  </>
                )}
                <p className="instrucoes-parcelamento">Clique em uma das opções abaixo para selecionar a quantidade de parcelas:</p>
                <div className="parcelas">
                  {loadingSimulacao && <Loader label="Carregando parcelas..." />}
                  {opcoesParcelamento.map((opcao) => (
                    <button
                      key={opcao.num_installments}
                      title={opcaoSelecionada?.num_installments === opcao.num_installments ? "Clique para desmarcar" : "Clique para selecionar"}
                      className={opcaoSelecionada?.num_installments === opcao.num_installments ? "selected" : ""}
                      onClick={handleSelecionarOpcao(opcao)}
                    >
                      <span className="quantidade">{opcao.num_installments}x</span>
                      <span className="descricao">{opcao.simulation}</span>
                      {opcao.discount_percent &&
                        <div>
                          <span className="desconto">{opcao.discount_percent}% de desconto</span>
                          <span className="valueWithoutDiscount">
                            ({opcao.value_saved})
                          </span>
                        </div>
                      }
                    </button>
                  ))}
                  {!loadingSimulacao && opcoesParcelamento.length === 0 && (
                    <div className="alert alert-warning">
                      O parcelamento em questão não alcançou o "Valor Mínimo da Parcela"
                      estabelecido no decreto Nº 17.015, Art. 7°, § 2º. Por isso
                      ele só poderá ser pago à vista. Para pagar à vista clique
                      no botão "Gerar boleto à vista".
                    </div>
                  )}
                </div>
                <Show if={showInformations}>
                  <div>
                    <div className="warning">
                      <FontAwesomeIcon icon={faExclamationCircle} />
                      <span>Leia o ato e concorde para prosseguir com a negociação.</span>
                    </div>
                    <div className="termsTittle">
                      <h6>ATO n° 001/2023</h6>
                      <h6>Fortaleza/CE, 09 de janeiro de 2023</h6>
                    </div>
                    <div className="termContent">
                      <span className="termTheme"><strong>Tema:</strong> prescrição no parcelamento</span>
                      <span className="terTextContent">
                        <p>
                          Declaro estar ciente de que o pedido de parcelamento do crédito tributário,
                          presencial ou online, interrompe a prescrição (o prazo de cobrança volta a correr do zero)
                          e implica no reconhecimento da existência da dívida mediante confissão extrajudicial,
                          ainda que posteriormente indeferido ou não paga a primeira parcela
                          (Código Tributário Nacional, art. 174, parágrafo único, inciso IV - STJ, Súmula 653).
                        </p>
                      </span>
                    </div>
                    <div className="acceptBox">
                      <input type="checkbox" onClick={termsAccepted}></input>
                      <span>CONCORDO</span>
                    </div>
                  </div>
                </Show>
                <p className="infos">
                  Informamos que os valores acima apresentados são apenas uma simulação.
                  Ao efetuar o parcelamento, os valores das parcelas serão reajustados
                  mensalmente conforme a legislação vigente (SELIC).
                </p>
                <div className="inputEmail">
                  <Show if={showInformations}>
                    <span>Digite seu e-mail.</span>
                    <input
                      id="emailrequired"
                      type="text"
                      placeholder="seuemail@email.com"
                      className="emailForCodeInput"
                      onChange={(e) => updateAndValidate(e.target.value)}
                      onBlur={(e) => setContributorEmail(e.target.value.trim())}
                      autoComplete="off"
                    />
                  </Show>
                </div>
                <div className="actions">
                  {!loadingSimulacao && opcoesParcelamento.length === 0 && (
                    <>
                      <button
                        className="btn btn-outline-primary"
                        disabled={loading}
                        onClick={handleDesistirParcelamento}
                      >
                        Fechar
                      </button>
                      <button
                        className="btn btn-primary"
                        disabled={loading}
                        onClick={() => handleSubmit()}
                      >
                        {!loading && "Gerar boleto à vista"}
                        {loading && "Gerando boleto à vista..."}
                      </button>
                    </>
                  )}
                  {!loadingSimulacao && opcoesParcelamento.length > 0 && (
                    <button
                      className="btn btn-primary"
                      disabled={!(acceptTerms && validEmail)}
                      onClick={aceptAndContinue}
                    >
                      Efetuar parcelamento
                    </button>
                  )}
                </div>
              </div>
            </Show>
            <Show if={showConfirmarParcelamento}>
              <div className="simulacao-parcelamento">
                {errorEfetuarParcelamento && <Alert>{errorEfetuarParcelamento}</Alert>}
                <h2>Informações importantes!</h2>
                <ul>
                  <li>1. Para ativar o parcelamento é preciso efetuar o pagamento da primeira parcela.</li>
                  <li>2. Se a ativação não for feita até o vencimento, o parcelamento será cancelado.</li>
                  <li>3. Se o parcelamento estiver ativo e acumular três parcelas não pagas, o parcelamento será perdido.</li>
                  <li>4. As parcelas, da segunda em diante, ficarão com o vencimento para o último dia útil de cada mês.</li>
                  <li>5. A cada parcelamento perdido, o próximo parcelamento efetuado sofrerá uma redução de até 6 parcelas.</li>
                </ul>.
                <h2>Somente para REFIS - Taxa do Lixo (LEI Nº 11.521):</h2>
                <ul>
                  <li>6. O parcelamento será cancelado automaticamente nas seguintes hipóteses:</li>
                  <ul>
                    <li>I - inadimplemento de 3 (três) parcelas consecutivas ou alternadas;</li>
                    <li>II - inadimplência de qualquer parcela por período superior a 3 (três) meses.</li>
                  </ul>
                  <li>7. O cancelamento do parcelamento implicará a exigibilidade imediata do saldo devedor remanescente e sua inscrição ou reinscrição na Dívida Ativa do Município, perdendo-se os descontos a que se refere o art. 8º desta Lei sobre o saldo remanescente.</li>
                </ul>
                <div className="actions">
                  <button
                    className="btn btn-outline-primary"
                    disabled={loadingEfetuarParcelamento}
                    onClick={handleDesistirParcelamento}
                  >
                    Desistir
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={loadingEfetuarParcelamento}
                    onClick={handleEfetuarParcelamento}
                  >
                    Ok. Efetuar parcelamento!
                  </button>
                </div>
              </div>
            </Show>
          </Modal>
        </Show>
        <div className="contentInformation">
            {datas.map((data, index) => {
              var groupId: Array<string> = []
              var groupnumber = 1;
              var groupnumberNegotiations = 1
              var oppenedInsciptions = 0;
              var groupValue = 0;
              var groupValueLegalAction = 0;
              var balanceToLegalAction = 0;
              var isrefisEnabled : boolean;
              var inscriptionTitle;
              var dynamicId = 0;
              let totalTributeValue: number = 0;
              var requestedAt: string;
              var paymentCode: string | null;

              if (data.title === "A inscrever") {
                if (data.data.length === 0) {
                  return null;
                }
                return (
                  <ItemSituacao
                    key={data.title}
                    title={data.title}
                    subtitle={data.subtitle}
                    showed={data.showed}
                  >
                    <ItemSituacaoEmpty>Existem créditos a inscrever. Por favor, procure o atendimento presencial.</ItemSituacaoEmpty>
                  </ItemSituacao>
                );
              }
            {data.title !== "Quitado" && data.data.map((inscriptionGroup) => (
              !(groupId.includes(inscriptionGroup.group_payment)) && groupId.push(inscriptionGroup.group_payment)
            ))}
            return (
              <div>
                {error && <Alert>{error}</Alert>}
                {index === 0 &&
                  (<p className="initialInformation">
                    <span>
                      {data.data.some(inscricao =>
                          inscricao.refis_enabled === true &&
                          ((inscricao.refis_rule_id !== undefined && ENABLED_REFIS_RULE_ID.includes(inscricao.refis_rule_id)) ||
                          inscricao.payment_request_code === null)
                        ) ?
                          returnTributeValuesRefisEnabled()
                        : returnTributeValues()
                      }
                    </span>
                  </p>)}
                {data.title === "Quitado" && (
                  <div className="extinticGroupBody" id="extinticGroup">
                    <div className="extinctGroupment" id="extinticGroup" onClick={(e) => {setVisibleExtinctCdas(e.currentTarget.id)}}>
                      <div className="groupmentInformations">
                        <strong>Extintos </strong>
                        <span>
                          {extinctCdasLoaded
                            ? data.subtitle
                            : data.subtitle}
                        </span>
                      </div>
                      <div className="groumpentValues">
                        <strong className="colapseIconExtintic">
                          {document.getElementById("extinticGroup")?.classList.contains("extinticGroupBodySelected") ?
                            <FontAwesomeIcon icon={icon} title={iconTitle} /> :
                            <FontAwesomeIcon icon={icon2} title={iconTitle2} />
                          }
                        </strong>
                      </div>
                    </div>
                    <div>
                      <Show if={extinctCda}>
                        <div className="extinctGroupmentDebt">
                          {loadingExtinctCdas && <Loader label="Carregando inscrições extintas..." />}
                          {errorExtinctCdas && <Alert>{errorExtinctCdas}</Alert>}
                          {!loadingExtinctCdas && extinctCdasLoaded && data.data.length === 0 && (
                            <ItemSituacaoEmpty>Não foram encontradas inscrições extintas para os dados informados.</ItemSituacaoEmpty>
                          )}
                          {data.data.map((inscricao) => (
                            <ItemInscricao
                              key={inscricao.id}
                              inscriptionId={inscricao.id}
                              inscricaoAdministrativa={inscricao.administrative_inscription}
                              balanceToLegalAction ={inscricao.balance_to_legal_action}
                              saldoDevedor={inscricao.balance}
                              numeroCda={inscricao.cda}
                              status={inscricao.state_pt_br}
                              documento={documento}
                              numeroParcelamento={inscricao.payment_request_code}
                              exercise={inscricao.debts[0].fiscal_date}
                              registry={inscricao.debts[0].protests_info[0]?.registry_name}
                              registryAddress={inscricao.debts[0].protests_info[0]?.full_address}
                              registryPhone={inscricao.debts[0].protests_info[0]?.registry_phone}
                              selected={!!inscricao.selected}
                              locked={!inscricao.group_payment}
                              onSelect={handleSelect(inscricao)}
                              phase={inscricao.phases}
                              processNumber={inscricao.judicial_process_number}
                              groupPayment={inscricao.group_payment}
                              refis_enabled={inscricao.refis_enabled &&
                                ((inscricao.refis_rule_id !== undefined && ENABLED_REFIS_RULE_ID.includes(inscricao.refis_rule_id)) || inscricao.payment_request_code === null)}
                              balance_to_l_action={inscricao.balance_to_legal_action}
                              full_address={inscricao.full_address}
                              attendantCounter={showAddress}
                              receipt_type_id={inscricao.receipt_type_id}
                              >
                                {inscricao.debts.map((debito) => (
                                  <ItemDebito
                                    key={debito.id}
                                    exercicio={debito.fiscal_date}
                                    valor={debito.debt_balance}
                                    status={debito.status}
                                  />
                                ))}
                            </ItemInscricao>
                          ))}
                        </div>
                      </Show>
                    </div>
                  </div>
                )}
                {groupId.map((groupments) => {
                  let withStateRestriction = false;
                  let withJudicialProcess = false;
                  let penalty = false;
                  if (groupments != null || (groupments == null && data.showed == true)){
                    oppenedInsciptions = 0;
                    groupValue = 0;
                    groupValueLegalAction = 0;
                    var isAgreement = false;
                    var inscriptionId: number;
                    data.data.map((inscricao) => {
                      if (inscricao.group_payment == groupments && inscricao.payment_request_code != null ) {
                        isAgreement = true;
                        inscriptionId = inscricao.id;
                      }
                      if (inscricao.group_payment == groupments && inscricao.with_state_restriction == true) {
                        withStateRestriction = true;
                      }
                      if (inscricao.group_payment == groupments && inscricao.judicial_process_number && !inscricao.penalty) {
                        withJudicialProcess = true;
                      }
                      if(inscricao.group_payment == groupments && inscricao.penalty){
                        penalty = true
                      }
                    })
                    return (
                      <div className="groupBody" id={groupments != null ? groupments : 'sent_protest'}>
                        <div className={`${isAgreement ? 'negotiationGroupment' : 'groupments'}`} id={groupments != null ? groupments : 'sent_protest'} onClick={(e) => {isAgreement ? setVisibleCdasNegotiation(e.currentTarget.id) : setVisibleCdas(e.currentTarget.id)}}>
                          <div className="groupmentInformations">
                            {data.data.map((inscricao) => {
                              if(inscricao.group_payment == groupments && data.showed == true){
                                oppenedInsciptions ++
                                groupValue =  groupValue + inscricao.balance
                                groupValueLegalAction = groupValueLegalAction + inscricao.balance_to_legal_action
                                isrefisEnabled = inscricao.refis_enabled &&
                                  ((inscricao.refis_rule_id !== undefined && ENABLED_REFIS_RULE_ID.includes(inscricao.refis_rule_id)) || inscricao.payment_request_code === null);
                                requestedAt = inscricao.requested_at
                                paymentCode = inscricao.payment_request_code
                              }
                              return null;
                            })}
                            <strong>
                              {isAgreement ? `Negociação ${groupnumberNegotiations ++}` : withStateRestriction ? `Dívidas em aberto com restrição` :
                                                                    withJudicialProcess ? `Dívidas em fase Judicial` : 'Dívidas em fase Administrativa'}
                              <span className="requestedDate">{isAgreement && `Data da negociação: ${moment(requestedAt).format('DD/MM/YYYY [às] HH:mm')}`}</span>
                            </strong>
                            {groupmentTitle(oppenedInsciptions, isAgreement)}
                          </div>
                          <div className={`${isrefisEnabled ? "groumpentValuesWithRefis" : "groumpentValues"}`} id={(groupValue).toFixed(2).toString()}>
                            <div id={groupments != null ? groupments : 'sent_protest'} className="groupGeneralValue">
                              <strong>{`${ isAgreement ? 'Total: ' : 'Total em aberto: '}`}</strong>
                              <span>{Format.currency(groupValueLegalAction)}</span>
                              <strong className="colapseIcon">
                                {id == groupmentsString(groupments) ? <FontAwesomeIcon icon={icon} title={iconTitle} /> : <FontAwesomeIcon icon={icon2} title={iconTitle2} />}
                              </strong>
                            </div>
                            <div className="groupmentValuesWithREFIS">
                              <Show if={isrefisEnabled}>
                                <div id="refisValueInfo">
                                  <strong>{`${ isAgreement ? 'Total com ' : 'Total em aberto com '}`}</strong>
                                  <div className="ifRefisEnabled">
                                    <span>REFIS</span>
                                  </div>
                                  :
                                  <strong className="balanceToLegalAction">
                                    {Format.currency(groupValue)}
                                  </strong>
                                </div>
                              </Show>
                              <strong className="colapseIconRefisValue">
                                {id == groupmentsString(groupments)
                                  ? <FontAwesomeIcon icon={icon} title={iconTitle} />
                                  : <FontAwesomeIcon icon={icon2} title={iconTitle2} />}
                              </strong>
                            </div>
                            <div className="dynamicGroupHide" id="dynamicGroupInfo">
                              <strong>Total Selecionado: </strong>
                              <span className="totalSelected">{Format.currency(selectedValue)}</span>
                              <strong className="colapseIconSelected">
                                {id == groupmentsString(groupments) ? <FontAwesomeIcon icon={icon} title={iconTitle} /> : <FontAwesomeIcon icon={icon2} title={iconTitle2} />}
                              </strong>
                            </div>
                            <div className="dynamicGroupHide" id="dynamicGroupInfoREFIS">
                              <Show if={isrefisEnabled}>
                                <div id="refisValueInfo">
                                  <strong>Total Selecionado com</strong>
                                  <div className="ifRefisEnabled">
                                    <span>REFIS</span>
                                  </div>
                                  <strong>: </strong>
                                  <span className="totalSelected">{Format.currency(selectedRefisValue)}</span>
                                </div>
                              </Show>
                              <strong className="colapseIconRefisValue">
                                {id == groupmentsString(groupments)
                                  ? <FontAwesomeIcon icon={icon} title={iconTitle} />
                                  : <FontAwesomeIcon icon={icon2} title={iconTitle2} />}
                              </strong>
                            </div>
                          </div>
                        </div>
                        <Show if={id == groupmentsString(groupments)}>
                          <div className="groupmentDebt">
                            <Show if={isrefisEnabled && refisBannerEnabled}>
                              <RefisBannerInstallments
                                inscriptions={data.data}
                                onClick={(installments: OpcaoParcelamento, inscriptions: number[]) => handleBannerClick(installments, inscriptions)}
                              />
                            </Show>
                            <div className="inscriptionsCounter">
                              {selecteds == 0 && isAgreement == false ? <span className="selectDebts">
                              {groupments != null
                                ? "Selecione os débitos desse agrupamento que deseja negociar:"
                                : "Agrupamento em fase indisponível para negociação"}</span>
                                : isAgreement ?
                                <div className="selectDebtsAgreement">
                                  Caso queira quitar antecipadamente uma negociação ou CDA específica, selecione e clique em "Gerar boleto"
                                </div>
                              : <span className="selectDebts">
                                  Clique nos botões ao lado para gerar boleto parcelado ou à vista:
                                </span>}
                            </div>
                            <div className="paymentGroupOptions">
                              <div className="rightInformationspayment">
                                <div className="selectionInformations">
                                  <Show if={groupmentsString(groupments) != 'sent_protest'}>
                                    <div className="selectAllButton" id="selectAll" onClick={(e) => {selectAllInscriptions(e.currentTarget.id)}}>
                                      <input type="checkbox" id="checkboxId" checked={isChecked}></input>
                                      <span> Selecionar todos</span>
                                    </div>
                                  </Show>
                                  <div className="clearAllSelectionsInvisible" id="clearButton" onClick={clearSelections}>
                                    <span>Limpar seleção</span>
                                  </div>
                                </div>
                              </div>
                              <div className="leftInformationspayment">
                                <div className="paymentButtons">
                                  <div>
                                    <Button
                                      label={isAgreement ? `Consultar parcelamento ${paymentCode}` : 'Simular Parcelamento'}
                                      loadingLabel="Carregando opções..."
                                      disabled={isAgreement ? isProcessingBillet : totalSelected === 0 || isProcessingBillet}
                                      loading={loadingSimulacao}
                                      onClick={isAgreement ? () => {handleToConsultNegotiation(inscriptionId)} : handleVerificaInscricoesComRestricoes}
                                      title={`${mensagemSelecioneCreditos}.`}
                                    />
                                  </div>
                                  <div>
                                    <Button
                                      label="Gerar boleto à vista"
                                      loadingLabel="Gerando boleto à vista..."
                                      disabled={totalSelected === 0 || loadingPix}
                                      loading={loading}
                                      onClick={() => handleSubmit()}
                                      title={`${mensagemSelecioneCreditos}.`}
                                    />
                                  </div>
                                  <div>
                                    <Button
                                      label="Pagamento via pix"
                                      loadingLabel="Gerando pagamento..."
                                      disabled={totalSelected === 0 || loading || loadingSimulacao || loadingPix}
                                      loading={loadingPix}
                                      onClick={() => handlePixPayment()}
                                      type="button"
                                      title={`${mensagemSelecioneCreditos}.`}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {data.data.map((inscricao)=> {
                              if(inscricao.group_payment == groupments){
                                return (
                                  <div className="itemInscription" id="inscription">
                                    <ItemInscricao
                                    key={inscricao.id}
                                    inscriptionId={inscricao.id}
                                    inscricaoAdministrativa={inscricao.administrative_inscription}
                                    balanceToLegalAction ={inscricao.balance_to_legal_action}
                                    saldoDevedor={inscricao.balance}
                                    numeroCda={inscricao.cda}
                                    status={inscricao.state_pt_br}
                                    documento={documento}
                                    numeroParcelamento={inscricao.payment_request_code}
                                    exercise={inscricao.debts[0].fiscal_date}
                                    registry={inscricao.debts[0].protests_info[0]?.registry_name}
                                    registryAddress={inscricao.debts[0].protests_info[0]?.full_address}
                                    registryPhone={inscricao.debts[0].protests_info[0]?.registry_phone}
                                    selected={!!inscricao.selected}
                                    locked={!inscricao.group_payment}
                                    onSelect={handleSelect(inscricao)}
                                    phase={inscricao.phases}
                                    processNumber={inscricao.judicial_process_number}
                                    groupPayment={inscricao.group_payment}
                                    refis_enabled={inscricao.refis_enabled &&
                                      ((inscricao.refis_rule_id !== undefined && ENABLED_REFIS_RULE_ID.includes(inscricao.refis_rule_id)) || inscricao.payment_request_code === null)}
                                    balance_to_l_action={inscricao.balance_to_legal_action}
                                    full_address={inscricao.full_address}
                                    attendantCounter={showAddress}
                                    receipt_type_id={inscricao.receipt_type_id}
                                    >
                                      {inscricao.debts.map((debito) => (
                                        <ItemDebito
                                          key={debito.id}
                                          exercicio={debito.fiscal_date}
                                          valor={debito.debt_balance}
                                          status={debito.status}
                                        />
                                      ))}
                                    </ItemInscricao>
                                  </div>
                                )
                              }
                            })}
                          </div>
                        </Show>
                      </div>
                    )
                  }
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
